import React from 'react';
import { Paper, Grid, TextField, Button, Box, CircularProgress } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const SearchAndFilters = ({ 
  searchTerm, 
  setSearchTerm, 
  filterType, 
  setFilterType, 
  onRefresh, 
  updating 
}) => {
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Paper sx={{ p: 2, mb: 4, borderRadius: 2, boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)' }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Search leads by name, email, or company..."
            value={searchTerm}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: '#94a3b8', mr: 1 }} />,
            }}
            sx={{ 
              bgcolor: '#fff',
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              }
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ 
            display: 'flex', 
            gap: 1.5, 
            justifyContent: { xs: 'flex-start', md: 'flex-end' }, 
            flexWrap: 'wrap' 
          }}>
            <Button
              variant={filterType === 'all' ? 'contained' : 'outlined'}
              size="small"
              onClick={() => setFilterType('all')}
              sx={{ 
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                minWidth: 80,
                bgcolor: filterType === 'all' ? '#4f46e5' : 'transparent',
                borderColor: '#e2e8f0', 
                color: filterType === 'all' ? '#fff' : '#64748b',
                '&:hover': {
                  bgcolor: filterType === 'all' ? '#4338ca' : '#f8fafc',
                }
              }}
            >
              All Plans
            </Button>
            
            <Button
              variant={filterType === 'enterprise' ? 'contained' : 'outlined'}
              size="small"
              onClick={() => setFilterType('enterprise')}
              sx={{ 
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                minWidth: 80,
                bgcolor: filterType === 'enterprise' ? '#4f46e5' : 'transparent',
                borderColor: '#e2e8f0', 
                color: filterType === 'enterprise' ? '#fff' : '#64748b',
                '&:hover': {
                  bgcolor: filterType === 'enterprise' ? '#4338ca' : '#f8fafc',
                }
              }}
            >
              Enterprise
            </Button>
            
            <Button
              variant={filterType === 'professional' ? 'contained' : 'outlined'}
              size="small"
              onClick={() => setFilterType('professional')}
              sx={{ 
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                minWidth: 80,
                bgcolor: filterType === 'professional' ? '#4f46e5' : 'transparent',
                borderColor: '#e2e8f0', 
                color: filterType === 'professional' ? '#fff' : '#64748b',
                '&:hover': {
                  bgcolor: filterType === 'professional' ? '#4338ca' : '#f8fafc',
                }
              }}
            >
              Professional
            </Button>
            
            <Button
              variant={filterType === 'starter' ? 'contained' : 'outlined'}
              size="small"
              onClick={() => setFilterType('starter')}
              sx={{ 
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                minWidth: 80,
                bgcolor: filterType === 'starter' ? '#4f46e5' : 'transparent',
                borderColor: '#e2e8f0', 
                color: filterType === 'starter' ? '#fff' : '#64748b',
                '&:hover': {
                  bgcolor: filterType === 'starter' ? '#4338ca' : '#f8fafc',
                }
              }}
            >
              Starter
            </Button>
            
            {/* <Button
              variant="outlined"
              size="small"
              onClick={onRefresh}
              disabled={updating}
              sx={{ 
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                minWidth: 80,
                borderColor: '#e2e8f0', 
                color: '#64748b',
                '&:hover': {
                  bgcolor: '#f8fafc',
                }
              }}
            >
              {updating ? <CircularProgress size={16} /> : 'Refresh'}
            </Button> */}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SearchAndFilters;